import { render, staticRenderFns } from "./MyProjectContract.vue?vue&type=template&id=0efc5ea0&scoped=true"
import script from "./MyProjectContract.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyProjectContract.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./MyProjectContract.vue?vue&type=style&index=0&id=0efc5ea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efc5ea0",
  null
  
)

export default component.exports